module.exports = __webpack_public_path__ + "img/904197267.57b0afe4.jpg";